import { useCallback, useEffect, useState } from 'react';
import auth from '../../service/auth';
import { PageHeader, Card, Badge, Spinner, Select, Pagination, formatDate, statusColor } from '../../components/ui';

const LIMIT = 50;

function Tickets() {
  const [data, setData] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [offset, setOffset] = useState(0);
  const [campaignId, setCampaignId] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    auth.api('lists').then((lists) => setCampaigns(lists.campaigns || []));
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    const params = new URLSearchParams({ limit: LIMIT, offset });
    if (campaignId) params.set('campaign_id', campaignId);
    if (status) params.set('status', status);
    const result = await auth.api('tickets/page?' + params.toString());
    setData(result);
    setLoading(false);
  }, [offset, campaignId, status]);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Supprimer ce ticket ?")) return;
    await auth.api('ticket/' + id, { method: "DELETE" });
    await load();
  };

  return (
    <div>
      <PageHeader
        title="Tickets"
        subtitle={data ? `${data.total.toLocaleString("fr-FR")} accusés de réception Expo` : "Chargement…"}
      />

      <Card className="p-4 mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <Select value={campaignId} onChange={(e) => { setOffset(0); setCampaignId(e.target.value); }}>
            <option value="">Toutes les campagnes</option>
            {campaigns.map((c) => <option key={c.campaign_id} value={c.campaign_id}>{c.name}</option>)}
          </Select>
          <Select value={status} onChange={(e) => { setOffset(0); setStatus(e.target.value); }}>
            <option value="">Tous les statuts</option>
            <option value="expo_ok">expo_ok</option>
            <option value="expo_error">expo_error</option>
          </Select>
        </div>
      </Card>

      <Card>
        {loading ? <Spinner /> : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-slate-200 text-left text-slate-500">
                    <th className="px-4 py-3 font-medium">ID</th>
                    <th className="px-4 py-3 font-medium">Campagne</th>
                    <th className="px-4 py-3 font-medium">App</th>
                    <th className="px-4 py-3 font-medium">Token ID</th>
                    <th className="px-4 py-3 font-medium">Vague</th>
                    <th className="px-4 py-3 font-medium">Statut</th>
                    <th className="px-4 py-3 font-medium">Date</th>
                    <th className="px-4 py-3 font-medium text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((t) => (
                    <tr key={t.ticket_id} className="border-b border-slate-100 hover:bg-slate-50">
                      <td className="px-4 py-3 text-slate-400">{t.ticket_id}</td>
                      <td className="px-4 py-3 text-slate-700 max-w-[200px] truncate" title={t.campaign_name}>
                        {t.campaign_name || `#${t.campaign_id}`}
                      </td>
                      <td className="px-4 py-3"><Badge color="indigo">{t.app_name || "—"}</Badge></td>
                      <td className="px-4 py-3 text-slate-500">{t.token_id}</td>
                      <td className="px-4 py-3 text-slate-500">{t.vague}</td>
                      <td className="px-4 py-3"><Badge color={statusColor(t.status)}>{t.status}</Badge></td>
                      <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{formatDate(t.created_at)}</td>
                      <td className="px-4 py-3 text-right">
                        <button
                          onClick={() => remove(t.ticket_id)}
                          className="px-2.5 py-1 text-xs rounded-lg font-medium bg-rose-600 hover:bg-rose-700 text-white transition-colors"
                        >
                          Retirer
                        </button>
                      </td>
                    </tr>
                  ))}
                  {data.rows.length === 0 && (
                    <tr><td colSpan="8" className="px-4 py-8 text-center text-slate-400">Aucun ticket trouvé</td></tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="p-4 border-t border-slate-200">
              <Pagination total={data.total} limit={LIMIT} offset={offset} onPage={setOffset} />
            </div>
          </>
        )}
      </Card>
    </div>
  );
}

export default Tickets;
